function TemplatePointers() {
    return (
        <>
            <h1 className="text-2xl mt-8 font-bold">Welcome to Vistor Book</h1>
        
        </>
    )
}

export default TemplatePointers;
